import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { View, ViewComponent, ViewContainer, ViewControlType } from 'src/app/modules/core/store/models';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'topo-form-group-select',
    templateUrl: './form-group-select.component.html',
    styleUrls: ['./form-group-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FormGroupSelectComponent
        }
    ],
    standalone: false
})
export class FormGroupSelectComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input()
  set viewControlContainers(containers: ViewComponent[]) {
    const sortedContainers = [...containers].sort((a, b) =>
      a.name.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: 'base'
      })
    );

    this.viewControlContainers$.next(sortedContainers);
  }
  viewControlContainers$: BehaviorSubject<ViewComponent[]> = new BehaviorSubject<ViewComponent[]>([]);

  @Input()
  set selectedViewControlContainerUId(value: string) {
    this.selectedViewControlContainerUId$.next(value);
  }
  selectedViewControlContainerUId$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  @Output()
  changed = new EventEmitter<string>();

  onChange = value => {};
  onTouched = () => {};
  touched = false;
  formGroupName: string;
  destroy$: Subject<void> = new Subject<void>();
  isMenuActive: boolean;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    combineLatest([this.viewControlContainers$, this.selectedViewControlContainerUId$])
      .pipe(
        takeUntil(this.destroy$),
        filter(([containers, selectedContainerUId]) => !!containers && !!selectedContainerUId),
        tap(([containers, selectedContainerUId]) => {
          const container = containers.find(c => c.uId === selectedContainerUId);
          this.formGroupName = container?.name;
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.viewControlContainers$.complete();
    this.selectedViewControlContainerUId$.complete();
  }

  showHideMenu(isVisible: boolean): void {
    this.isMenuActive = isVisible;
  }

  writeValue(value: any) {
    this.selectedViewControlContainerUId = value;

    this.changeDetector.markForCheck();
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  viewContainerChanged($event: any) {
    this.markAsTouched();
    this.onChange(this.selectedViewControlContainerUId$.value);
    this.changed.emit(this.selectedViewControlContainerUId$.value);
  }

  selectViewControlContainer(viewControlContainer: ViewComponent): void {
    this.selectedViewControlContainerUId$.next(viewControlContainer.uId);
    this.onChange(this.selectedViewControlContainerUId$.value);
    this.markAsTouched();
    this.changed.emit(this.selectedViewControlContainerUId$.value);
  }
}
